import type { PropsWithChildren } from 'react';

import { RaisedFistIcon } from '@change/ds-icons';
import { cn } from '@change/ds-utils';

import { Button, Text } from '@change/ds-core-ui/next';

import { useActionButton } from './hooks/useActionButton';

type Props = {
	to: string;
	socialProof?: boolean;
	buttonName: string;
};

export function ActionButton({ to, socialProof, buttonName, children }: PropsWithChildren<Props>) {
	const {
		data: { socialProofLabel, hiddenOnMobile },
	} = useActionButton();

	return (
		<div
			className={cn(
				'fixed left-0 z-[2000] mt-0 w-full',
				'shadow-[0px_-0.7px_1.4px_rgba(0,0,0,0.07),_0px_-1.9px_4px_rgba(0,0,0,0.05),_0px_-4.5px_10px_rgba(0,0,0,0.05),_0px_-15px_32px_rgba(0,0,0,0.04)]',
				'md:static md:shadow-none',
				'focus-within:bottom-0 focus-within:outline-none',
				hiddenOnMobile ? '-bottom-[1000px]' : 'bottom-0',
			)}
		>
			<div className="bg-background-raised px-4 py-2 md:bg-transparent md:px-0 md:py-0">
				{socialProof && (
					<div className="rounded-large mb-2 flex flex-row items-center justify-center gap-2 md:hidden">
						<RaisedFistIcon size="x-small" />
						<Text size="small">{socialProofLabel}</Text>
					</div>
				)}

				<Button variant="primary" as="a" href={to} className="w-full md:w-auto" data-qa={`${buttonName}-button`}>
					{children}
				</Button>
			</div>
		</div>
	);
}
